"use client";

import { Plus, ArrowUpRight } from "lucide-react";
import TextGenerateEffect from "@/components/TextGenerateEffect";

/**
 * Contact page — fabrica-style editorial layout.
 *   - Hero: giant "Get in touch." headline.
 *   - Two-column body: copy + person card on the left, email CTA and
 *     socials on the right.
 */
const SOCIALS = [
  { label: "YouTube", href: "https://www.youtube.com/@burakozgurmd" },
  { label: "Instagram", href: "https://instagram.com/burakozgurmd" },
  { label: "Facebook", href: "https://facebook.com/BurakOzgurMD" },
  { label: "TikTok", href: "https://tiktok.com/@burak.ozgur.md" },
];

export default function ContactPage() {
  return (
    <main className="cp-page">
      <section className="cp-hero" data-bg-tint="cool">
        <TextGenerateEffect
          as="h1"
          words="Get in touch."
          className="cp-hero-title"
          duration={0.9}
          staggerDelay={0.07}
          filter={false}
        />
      </section>

      <section className="cp-grid" data-bg-tint="rose">
        <div className="cp-left">
          <TextGenerateEffect
            as="p"
            words="**Have a question or inquiry?** Reach out and we'll get back to you. A quick note: this inbox is for general inquiries — media, speaking, collaborations, and everything in between. For anything medical, please contact the office directly. Medical questions can't be addressed through this email — and please don't include personal health information, as this is not a HIPAA-compliant channel."
            className="cp-left-copy"
            duration={0.8}
            staggerDelay={0.03}
            filter={false}
            highlightColor="#1d1d1f"
          />

          <div className="cp-person">
            <img
              className="cp-person-avatar"
              src="https://for-media.b-cdn.net/ozgurmd/burak-ozgur-headshot-2.JPG"
              alt="Dr. Burak Ozgur"
            />
            <div className="cp-person-meta">
              <div className="cp-person-name">Burak Ozgur, MD</div>
              <div className="cp-person-role">
                Neurosurgeon &middot; Hoag Spine Institute
              </div>
            </div>
          </div>
        </div>

        <div className="cp-right">
          <a href="mailto:contact@ozgurmd.com" className="cp-submit">
            <span>Email Burak</span>
            <span className="cp-submit-dot" aria-hidden />
          </a>

          <div className="cp-detail-sep" aria-hidden>
            <Plus size={16} />
          </div>

          <div className="cp-details">
            <a href="mailto:contact@ozgurmd.com" className="cp-email">
              <Plus size={16} aria-hidden />
              <span>contact@ozgurmd.com</span>
            </a>
          </div>

          <ul className="cp-socials">
            {SOCIALS.map((s) => (
              <li key={s.href}>
                <a href={s.href} target="_blank" rel="noopener noreferrer">
                  <span>{s.label}</span>
                  <ArrowUpRight size={18} aria-hidden />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </main>
  );
}
